import { inject, Injectable } from '@angular/core';
import { ethers } from 'ethers';
import { AuthService } from '../abstraction/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ADDRESS_EVENT } from '../models/Whitelabel';

@Injectable({
  providedIn: 'root',
})
export class BalanceService {
  private TOKEN_ADDRESSES = [
    '0x2cfc85d8e48f8eab294be644d9e25c3030863003', // WLD
    '0x79A02482A880bCE3F13e09Da970dC34db4CD24d1', // USDC
  ];
  private tokenNames = {
    '0x2cfc85d8e48f8eab294be644d9e25c3030863003': 'WLD',
    '0x79A02482A880bCE3F13e09Da970dC34db4CD24d1': 'USDC',
  };
  private ERC20_ABI = [
    'function balanceOf(address owner) view returns (uint256)',
    'function decimals() view returns (uint8)',
  ];
  private provider: ethers.JsonRpcProvider;
  route = inject(ActivatedRoute);
  authService = inject(AuthService);

  constructor() {
    this.provider = new ethers.JsonRpcProvider('https://worldchain-mainnet.g.alchemy.com/public');
  }

  getWLDTokenBalance = async (
    walletAddress: string,
  ): Promise<{ WLD: string; USDC: string } | void> => {
    try {
      if (!walletAddress) throw new Error('No wallet address provided');
      let balances: { WLD: string; USDC: string } = { WLD: '0', USDC: '0' };
      if (walletAddress === ADDRESS_EVENT) {
        balances = { WLD: '0', USDC: '200' };
        this.authService.setBalanceMiniapp(balances);
        return;
      }

      for (const tokenAddress of this.TOKEN_ADDRESSES) {
        const contract = new ethers.Contract(tokenAddress, this.ERC20_ABI, this.provider);

        // Obtener el balance de cada token
        const balance = await contract.balanceOf(walletAddress);

        // Obtener los decimales del token
        const decimals = await contract.decimals();
        const tokenName = this.tokenNames[tokenAddress];
        const formatted = ethers.formatUnits(balance, decimals);
        const trimmed = formatted.includes('.')
          ? formatted.slice(0, formatted.indexOf('.') + 6)
          : formatted;
        balances[tokenName] = trimmed;
      }
      // Set balance in global state
      this.authService.setBalanceMiniapp(balances);
    } catch (error) {
      console.error('Error receive to balance:', error);
      throw error;
    }
  };

  generateFakeWallet(): string {
    const chars = 'abcdef0123456789';
    const randomPart = Array.from(
      { length: 32 },
      () => chars[Math.floor(Math.random() * chars.length)],
    ).join('');
    const timestampPart = Date.now().toString(16).slice(-8);
    return '0x' + (randomPart + timestampPart).slice(0, 40);
  }
}
